import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-textarea', {
	mixins: [FormElementMixin]
}, 'form/controls/ak-textarea.html');